"use client"

import { useEffect } from "react"
import { trackEvent } from "@/lib/analytics"

/** Meldet 404-Aufrufe an GA4 — zeigt tote Links/verirrte Besucher. */
export default function TrackNotFound() {
  useEffect(() => {
    trackEvent("page_not_found", { page_path: window.location.pathname, referrer: document.referrer || undefined })
  }, [])
  return null
}
